import { useAppSelector } from "@/stores/hook";
import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";

import ActionForStartApplication from "@/module/education/nicheSideRoutes/Course/actions/ActionForStartApplication";
import ActionsForEditMode from "@/features/leads/components/view-lead/components/Actions/ActionsForEditMode";
import AddApplicationAction from "@/module/education/nicheSideRoutes/Course/actions/AddApplicationAction";
import ActionForApplicationDetail from "@/features/leads/components/view-lead/components/Actions/ActionForApplicationDetail";
import ActionForNextFollowup from "@/features/leads/components/view-lead/components/Actions/ActionForNextFollowup";

export default function useActionResolver() {
  const { currentTab, selectedApplicationId, isEditMode } = useAppSelector(
    (state) => state.leadFunctional
  );

  const { industry } = useCurrentIndustry();
  const { courseDetailId, startApplication, isCourseDetails } = useAppSelector(
    (state) => state.educationSlice
  );

  if (isEditMode) {
    return <ActionsForEditMode />;
  }

  if (industry?.id === 1) {
    if (currentTab === "Course" && courseDetailId && isCourseDetails) {
      return <ActionForStartApplication />;
    } else if (currentTab === "Applications" && selectedApplicationId) {
      return <ActionForApplicationDetail />;
    } else if (startApplication) {
      return <AddApplicationAction />;
    }
  }

  if (currentTab === "Chat") {
    return null; // Chat tab renders its own input inside Chat.tsx
  }

  return <ActionForNextFollowup />;
}
